import React from 'react'
import {Button, Card, CardBody, Col, Form, FormGroup, Input, Modal, Row, Table} from "reactstrap";
import CardHeader from "reactstrap/es/CardHeader";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import localeHelpers from "../../helpers/LocaleHelper";
import {common_strings} from "../../translations/common_translations";
import resourceHelper from "../../helpers/ResourceHelper";
import {student_strings} from "../../translations/student_translations";
import ResourceApiService from "../../api/resource-api-service";
import CheckBoxList from "../Tables/CheckBoxList";
import constants from "../../shared/constants";
import businessHelper from "../../helpers/BusinessHelper";
import Badge from "reactstrap/es/Badge";
import groupHelpers from "../../helpers/GroupHelper";

let resourceStrings = new LocalizedStrings(resource_strings);
let commonStrings = new LocalizedStrings(common_strings);
let studentStrings = new LocalizedStrings(student_strings);

const propTypes = {};

class EditTicketTypeView extends React.Component {
    handleChange = this.handleChange.bind(this);
    updateTicketType = this.updateTicketType.bind(this);
    renderCTModal = this.renderCTModal.bind(this);
    renderTTModal = this.renderTTModal.bind(this);
    showCTModal = this.showCTModal.bind(this);
    handleClassTypeCbChange = this.handleClassTypeCbChange.bind(this);
    handleGroupCbChange = this.handleGroupCbChange.bind(this);
    handleTicketTypeCbChange = this.handleTicketTypeCbChange.bind(this);
    handleTicketTypeSelectionCbChange = this.handleTicketTypeSelectionCbChange.bind(this);
    handleCTSelected = this.handleCTSelected.bind(this);
    handleStudentGroupSelected = this.handleStudentGroupSelected.bind(this);
    handleTicketTypeSelected = this.handleTicketTypeSelected.bind(this);
    handleEndlessChange = this.handleEndlessChange.bind(this);
    handleUnlimitedChange = this.handleUnlimitedChange.bind(this);
    getClassTypes = this.getClassTypes.bind(this);
    handleActiveFromCb = this.handleActiveFromCb.bind(this);
    handleLimitChange = this.handleLimitChange.bind(this);
    setLimitUnits = this.setLimitUnits.bind(this);
    setMode = this.setMode.bind(this);
    toggleShowMembershipExplanation = this.toggleShowMembershipExplanation.bind(this);

    constructor(props) {
        super(props);
        this.state = {
            ticketType: props.ticketType || resourceHelper.emptyTicketType(),
            ticketTypes: props.ticketTypes || [],
            selectedTicketTypes: props.ticketType ? props.ticketType.covered_tickets : [],
            rooms: null,
            showCTModal: false,
            classTypes: null,
            mode: props.showMembership ? "m" : "t",
            selectedClassTypes: null,
            selectedStudentGroups: null,
            showMembershipExplanation: false,
            validation: {
                name: props.ticketType && props.ticketType.name && props.ticketType.name.length > 0,
                price: true,
                duration: true,
                classes_left: true
            },
            studentGroups: groupHelpers.groups(),
        };

        window.EditTicketTypeView = this
    }

    componentWillUnmount() {
        window.EditTicketTypeView = null
    }

    handleClassTypeCbChange(event) {

        let checked = event.target.checked;
        if (checked) {
            this.setState({selectedClassTypes: []})
        } else {
            this.showCTModal()
        }
    }

    handleGroupCbChange(event) {

        let checked = event.target.checked;
        if (checked) {
            this.setState({selectedStudentGroups: []})
        } else {
            this.showGroupModal()
        }
    }

    // FOR ENROLMENT TICKETS. SELECTION OF COVERED TICKET TYPES
    handleTicketTypeCbChange(event) {
        let checked = event.target.checked;
        if (checked) {
            this.setState({selectedTicketTypes: []})
        } else {
            this.showTTModal()
        }
    }

    // FOR REGULAR TICKETS. SELECTION OF COVERED TICKET TYPES
    handleTicketTypeSelectionCbChange(event) {
        let checked = event.target.checked;
        if (!checked) {
            this.setState({selectedTicketTypes: []})
        } else {
            this.showTTModal()
        }
    }

    handleChange(event) {

        let newValue = event.target.value;
        let targetId = event.target.id;
        let checkBoxValue = event.target.checked;

        switch (targetId) {
            case "input-name":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        name: newValue
                    }
                }));
                break;
            case "input-note":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        note: newValue
                    }
                }));
                break;
            case "input-duration":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        duration: newValue
                    }
                }));
                break;
            case "input-classes-left":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        classes_left: newValue
                    }
                }));
                break;
            case "input-price":
                const updatedPrice = parseFloat(newValue.replace(/,/g, '-.'));
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        price: updatedPrice
                    }
                }));
                break;
            case "input-public-cb":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        whitelisted: checkBoxValue
                    }
                }));
                break;
            case "input-enrolment-cb":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        is_enrolment: checkBoxValue
                    }
                }));
                break;
            case "input-renewable-cb":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        renewable: checkBoxValue
                    }
                }));
                break;
            case "input-one-timer-cb":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        is_one_timer: checkBoxValue
                    }
                }));
                break;
            case "input-workshop-cb":
                this.setState(prevState => ({
                    ticketType: {
                        ...prevState.ticketType,
                        is_workshop: checkBoxValue
                    }
                }));
                break;

            default:
                return
        }
    }

    componentWillUpdate(nextProps, nextState, nextContext) {
        if (nextProps.ticketType !== this.props.ticketType) {
            this.setState({
                ticketType: nextProps.ticketType,
            })
        }

    }

    componentDidMount() {
        // if (this.state.ticketType && this.state.ticketType.id && !this.state.ticketType.membership) {
        //     ResourceApiService.getPromoCodes(this.state.ticketType.id)
        //         .then(res => {
        //             this.setState({
        //                 promoCodes: res,
        //                 isLoading: false
        //             });
        //         })
        //         .catch((e) => {
        //             this.props.handleError(e)
        //         });
        // }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.ticketType !== this.state.ticketType) {
            this.handleValidation();
        }
    }

    setMode(e, mode) {
        e.preventDefault();
        this.setState({mode: mode});
    }

    render() {
        this.localize();

        return (
            <>
                {this.state.showCTModal &&
                    this.renderCTModal()
                }

                {this.state.mustShowGroupSelector &&
                    this.renderSgModal()
                }

                {this.state.showTTModal &&
                    this.renderTTModal()
                }
                <Card className="bg-secondary shadow">
                    <CardHeader className="bg-white border-0">
                        <Row className="align-items-center">
                            <Col xs="10">
                                <h3 className="mb-0">{this.state.ticketType.id ? resourceStrings.edit_ticket_type : resourceStrings.new_ticket_type}</h3>
                            </Col>

                            <Col xs="2">
                                <div className="modal-header float-right">
                                    <button
                                        aria-label="Close"
                                        className="close"
                                        data-dismiss="modal"
                                        type="button"
                                        onClick={e => this.props.closeTicketTypeView(e)}
                                    >
                                        <span aria-hidden={true}>×</span>
                                    </button>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                        <span style={{color: "gray", marginLeft: 20, marginRight: 20}}>
                                <small>{resourceStrings.tt_expl}</small>
                            </span>
                        </Row>
                    </CardHeader>
                    <CardBody>
                        {!this.state.ticketType.id &&
                            <Row className="pl-lg-4 mb-4">
                                <Col>
                                    <Button
                                        style={{width: "100%"}}
                                        color={this.state.mode == "t" ? "default" : "secondary"}
                                        size="lg"
                                        onClick={e => this.setMode(e, "t")}
                                    >
                                        {resourceStrings.ticket}
                                    </Button>
                                </Col>

                                <Col>
                                    <Button
                                        style={{width: "100%"}}
                                        color={this.state.mode == "m" ? "warning" : "secondary"}
                                        size="lg" s
                                        onClick={e => this.setMode(e, "m")}
                                    >
                                        {resourceStrings.membership} <Badge color="primary">new</Badge>
                                    </Button>
                                </Col>
                            </Row>
                        }
                        {this.state.mode == "t" &&
                            <Form onSubmit={this.handleSubmit}>
                                {this.state.ticketType &&
                                    <div className="pl-lg-4">
                                        <Row>
                                            <Col lg="12">
                                                <FormGroup style={{verticalAlign: 'center='}}>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-name"
                                                    >
                                                        {resourceStrings.title}
                                                    </label>
                                                    <Input
                                                        placeholder={resourceStrings.title}
                                                        className={this.state.validation.name === true ? "form-control-alternative" : "is-invalid"}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.ticketType.name}
                                                        id="input-name"
                                                        type="name"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg="12">
                                                <FormGroup style={{verticalAlign: 'center='}}>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-note"
                                                    >
                                                        {resourceStrings.description}
                                                    </label>
                                                    <Input
                                                        placeholder={resourceStrings.tt_description_placeholder}
                                                        className={"form-control-alternative"}
                                                        onChange={this.handleChange}
                                                        defaultValue={this.state.ticketType.note}
                                                        id="input-note"
                                                        rows="2"
                                                        type="textarea"
                                                    />
                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        {!this.state.ticketType.membership &&
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup style={{verticalAlign: 'center='}}>

                                                        <div
                                                            className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                            <input
                                                                className="custom-control-input"
                                                                id="input-enrolment-cb"
                                                                onChange={this.handleChange}
                                                                checked={this.state.ticketType.is_enrolment == true}
                                                                type="checkbox"
                                                            />
                                                            <label className="custom-control-label"
                                                                   htmlFor="input-enrolment-cb">
                                                                {resourceStrings.is_enrolment}
                                                            </label>
                                                            <div>
                                                                <i><small>{resourceStrings.enrolment_expl}</small></i>
                                                            </div>
                                                            .
                                                        </div>

                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        }

                                        {!this.state.ticketType.is_enrolment &&
                                            <Row>
                                                <Col lg="12">
                                                    <FormGroup style={{verticalAlign: 'center='}}>
                                                        <label
                                                            className="form-control-label"
                                                            htmlFor="input-duration"
                                                        >
                                                            {resourceStrings.ticket_valid_for}
                                                        </label>

                                                        {this.state.ticketType.duration !== constants.open.ENDLESS_TICKET &&
                                                            <Row className="align-content-center"
                                                                 style={{display: "flex", alignItems: "center"}}>
                                                                <Col lg="2">
                                                                    <Input
                                                                        disabled={this.state.ticketType.membership}
                                                                        placeholder={resourceStrings.duration}
                                                                        className="form-control-alternative"
                                                                        onChange={this.handleChange}
                                                                        value={this.ticketDuration()}
                                                                        id="input-duration"
                                                                        type="number"
                                                                    />
                                                                </Col>
                                                                <Col lg="4">
                                                                    <Button
                                                                        disabled={this.state.ticketType.membership}
                                                                        color={this.state.ticketType.units === "d" ? "warning" : "secondary"}
                                                                        size="sm"
                                                                        onClick={e => this.setUnits(e, "d")}
                                                                    >
                                                                        {resourceStrings.ticket_days}
                                                                    </Button>

                                                                    <Button
                                                                        color={this.state.ticketType.units === "m" ? "warning" : "secondary"}
                                                                        size="sm"
                                                                        onClick={e => this.setUnits(e, "m")}
                                                                    >
                                                                        {resourceStrings.ticket_months}
                                                                    </Button>
                                                                </Col>
                                                            </Row>
                                                        }

                                                        {!this.state.ticketType.membership &&
                                                            <div
                                                                className="custom-control custom-control-alternative custom-checkbox mb-3 mt-2">
                                                                <input
                                                                    className="custom-control-input"
                                                                    id="input-endless-cb"
                                                                    onChange={this.handleEndlessChange}
                                                                    checked={this.state.ticketType.duration === constants.open.ENDLESS_TICKET}
                                                                    type="checkbox"
                                                                />
                                                                <label className="custom-control-label"
                                                                       htmlFor="input-endless-cb">
                                                                    {resourceStrings.ticket_never_expires}
                                                                </label>
                                                            </div>
                                                        }
                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        }

                                        {!this.state.ticketType.is_enrolment &&
                                            <>
                                                <hr style={{marginTop: -2}}/>
                                                <Row>
                                                    {/*DURAION*/}
                                                    <Col lg="12">
                                                        <FormGroup style={{verticalAlign: 'center='}}>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-duration"
                                                            >
                                                                {resourceStrings.ticket_duration}
                                                            </label>

                                                            <Row style={{display: "flex", alignItems: "center"}}>
                                                                {this.state.ticketType.classes_left > -1 &&
                                                                    <Col lg="2">
                                                                        <div>
                                                                            <Input
                                                                                placeholder={resourceStrings.classes}
                                                                                className={this.state.validation.classes_left === true ? "form-control-alternative" : "is-invalid"}
                                                                                onChange={this.handleChange}
                                                                                value={this.state.ticketType.classes_left}
                                                                                id="input-classes-left"
                                                                                type="number"
                                                                                min={0}
                                                                            />

                                                                        </div>

                                                                    </Col>
                                                                }
                                                                {this.state.ticketType.classes_left > -1 &&
                                                                    <Col lg="2">
                                                                        {resourceStrings.classes}
                                                                    </Col>
                                                                }
                                                                <Col lg="6">
                                                                    <div
                                                                        className="custom-control custom-control-alternative custom-checkbox">
                                                                        <input
                                                                            className="custom-control-input"
                                                                            id="input-unlimited-cb"
                                                                            onChange={this.handleUnlimitedChange}
                                                                            checked={this.state.ticketType.classes_left === constants.open.UNLIMITED_TICKET}
                                                                            type="checkbox"
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="input-unlimited-cb">
                                                                            {resourceStrings.unlimited_ticket}
                                                                        </label>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        }

                                        <hr style={{marginTop: -2}}/>
                                        <Row>
                                            {/*PRICE*/}
                                            <Col lg="12">
                                                <FormGroup style={{verticalAlign: 'center='}}>
                                                    <label
                                                        className="form-control-label"
                                                        htmlFor="input-price"
                                                    >
                                                        {resourceStrings.price}
                                                    </label>

                                                    <Row style={{display: "flex", alignItems: "center"}}>
                                                        <Col lg="2" md="2" sm="8" xs="8">
                                                            <div>
                                                                <Input
                                                                    disabled={this.state.ticketType.membership}
                                                                    className={this.state.validation.price === true ? "form-control-alternative" : "is-invalid"}
                                                                    onChange={this.handleChange}
                                                                    value={this.state.ticketType.price}
                                                                    id="input-price"
                                                                    type="number"
                                                                    min={0}
                                                                    pattern="^\d+(?:\.\d{1,2})?$"
                                                                    placeholder="0.00"
                                                                />

                                                            </div>

                                                        </Col>
                                                        <Col lg="2" md="2" sm="4" xs="4">
                                                            {businessHelper.currency()}
                                                        </Col>
                                                    </Row>

                                                </FormGroup>
                                            </Col>
                                        </Row>

                                        {!this.state.ticketType.membership &&
                                            <Row>
                                                {/*PROMO CODES*/}
                                                <Col lg="12">
                                                    <FormGroup style={{verticalAlign: 'center='}}>
                                                        <label
                                                            className="form-control-label"
                                                            htmlFor="input-price"
                                                        >
                                                            {resourceStrings.promo_codes}
                                                        </label>

                                                        <div>
                                                            <i><small
                                                                style={{fontWeight: 600}}>{resourceStrings.promo_codes_expl_new}</small></i>
                                                            <a href="https://dashboard.stripe.com/coupons"
                                                               target="_blank">Stripe {resourceStrings.promo_codes}</a>
                                                        </div>

                                                    </FormGroup>
                                                </Col>
                                            </Row>
                                        }

                                        {!this.state.ticketType.is_enrolment &&
                                            <>
                                                <hr style={{marginTop: -2}}/>
                                                <Row>
                                                    {/*ACTIVE FROM*/}
                                                    <Col lg="12">
                                                        <FormGroup style={{verticalAlign: 'center='}}>
                                                            <label
                                                                className="form-control-label"
                                                                htmlFor="input-duration"
                                                            >
                                                                {resourceStrings.active_from}
                                                            </label>

                                                            <Row style={{display: "flex", alignItems: "center"}}>
                                                                <Col lg="6">
                                                                    <div
                                                                        className="custom-control custom-control-alternative custom-checkbox">
                                                                        <input
                                                                            className="custom-control-input"
                                                                            id="input-first-cb"
                                                                            onChange={e => this.handleActiveFromCb(e, "f")}
                                                                            checked={this.state.ticketType.start_first_day === true}
                                                                            type="checkbox"
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="input-first-cb">
                                                                            {resourceStrings.active_from_first}
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="custom-control custom-control-alternative custom-checkbox mt-2">
                                                                        <input
                                                                            className="custom-control-input"
                                                                            id="input-day-cb"
                                                                            onChange={e => this.handleActiveFromCb(e, "d")}
                                                                            checked={(this.state.ticketType.start_first_day != true && this.state.ticketType.starts_on_use != true)}
                                                                            type="checkbox"
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="input-day-cb">
                                                                            {resourceStrings.active_from_day}
                                                                        </label>
                                                                    </div>
                                                                    <div
                                                                        className="custom-control custom-control-alternative custom-checkbox mt-2">
                                                                        <input
                                                                            className="custom-control-input"
                                                                            id="input-start-on-use-cb"
                                                                            disabled={this.state.ticketType.membership}
                                                                            onChange={e => this.handleActiveFromCb(e, "u")}
                                                                            checked={this.state.ticketType.starts_on_use == true}
                                                                            type="checkbox"
                                                                        />
                                                                        <label className="custom-control-label"
                                                                               htmlFor="input-start-on-use-cb">
                                                                            {resourceStrings.active_from_first_use}
                                                                        </label>
                                                                    </div>
                                                                </Col>
                                                            </Row>

                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        }

                                        {!this.state.ticketType.is_enrolment &&
                                            <>
                                                <hr style={{marginTop: -2}}/>
                                                <Row>
                                                    {/*LIMIT BY WEEK DAY*/}
                                                    <Col lg="12">
                                                        <FormGroup style={{verticalAlign: 'center='}}>
                                                            <label
                                                                className="form-control-label"
                                                            >
                                                                {resourceStrings.limit_by_day_week_expl}
                                                            </label>

                                                            {(this.state.ticketType.limit && this.state.ticketType.limit.length > 1) &&
                                                                <Row className="align-content-center"
                                                                     style={{display: "flex", alignItems: "center"}}>
                                                                    <Col lg="2">
                                                                        <Input
                                                                            placeholder={resourceStrings.duration}
                                                                            className={this.state.validation.duration === true ? "form-control-alternative" : "is-invalid"}
                                                                            onChange={this.handleLimitChange}
                                                                            value={this.getLimitValue()}
                                                                            id="input-limit"
                                                                            min={0}
                                                                            type="number"
                                                                        />
                                                                    </Col>
                                                                    <Col lg="2">
                                                                        {resourceStrings.times_per}
                                                                    </Col>
                                                                    <Col lg="4">
                                                                        <Button
                                                                            color={(this.state.ticketType.limit && this.state.ticketType.limit.includes("d")) ? "warning" : "secondary"}
                                                                            size="sm"
                                                                            onClick={e => this.setLimitUnits(e, "d")}
                                                                        >
                                                                            {commonStrings.day}
                                                                        </Button>

                                                                        <Button
                                                                            color={(this.state.ticketType.limit && this.state.ticketType.limit.includes("w")) ? "warning" : "secondary"}
                                                                            size="sm"
                                                                            onClick={e => this.setLimitUnits(e, "w")}
                                                                        >
                                                                            {commonStrings.week}
                                                                        </Button>
                                                                    </Col>
                                                                </Row>
                                                            }

                                                            <div
                                                                className="custom-control custom-control-alternative custom-checkbox mb-3 mt-2">
                                                                <input
                                                                    className="custom-control-input"
                                                                    id="input-no-limit-cb"
                                                                    onChange={event => this.handleNoLimitChange(event)}
                                                                    checked={(!this.state.ticketType.limit || this.state.ticketType.limit.length < 2)}
                                                                    type="checkbox"
                                                                />
                                                                <label className="custom-control-label"
                                                                       htmlFor="input-no-limit-cb">
                                                                    {resourceStrings.no_limit_by_day_week}
                                                                </label>
                                                            </div>
                                                        </FormGroup>
                                                    </Col>
                                                </Row>
                                            </>
                                        }

                                        <hr style={{marginTop: -2}}/>

                                        <Row>
                                            <Col lg="12">
                                                <div
                                                    className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                    <input
                                                        className="custom-control-input"
                                                        id="input-public-cb"
                                                        onChange={this.handleChange}
                                                        checked={this.state.ticketType.whitelisted === true}
                                                        type="checkbox"
                                                    />
                                                    <label className="custom-control-label" htmlFor="input-public-cb">
                                                        {resourceStrings.public}
                                                    </label>
                                                    <div>
                                                        <i><small>{resourceStrings.public_ticket_expl}</small></i>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>

                                        {!this.state.ticketType.membership && !this.state.ticketType.is_enrolment &&
                                            <Row>
                                                <Col lg="12">
                                                    <div
                                                        className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                        <input
                                                            className="custom-control-input"
                                                            id="input-renewable-cb"
                                                            onChange={this.handleChange}
                                                            checked={this.state.ticketType.renewable === true}
                                                            type="checkbox"
                                                        />
                                                        <label className="custom-control-label"
                                                               htmlFor="input-renewable-cb">
                                                            {resourceStrings.subscription}
                                                        </label>
                                                        <div>
                                                            <i><small>{resourceStrings.subscription_expl}</small></i>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }

                                        {!this.state.ticketType.membership && !this.state.ticketType.is_enrolment &&
                                            <Row>
                                                <Col lg="12">
                                                    <div
                                                        className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                        <input
                                                            className="custom-control-input"
                                                            id="input-one-timer-cb"
                                                            onChange={this.handleChange}
                                                            checked={this.state.ticketType.is_one_timer === true}
                                                            type="checkbox"
                                                        />
                                                        <label className="custom-control-label"
                                                               htmlFor="input-one-timer-cb">
                                                            {resourceStrings.one_timer}
                                                        </label>
                                                        <div>
                                                            <i><small>{resourceStrings.one_timer_expl}</small></i>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }

                                        {!this.state.ticketType.is_enrolment &&

                                            <Row>
                                                <Col lg="12">
                                                    <div
                                                        className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                        <input
                                                            className="custom-control-input"
                                                            id="input-tt-cb"
                                                            onChange={this.handleClassTypeCbChange}
                                                            checked={!this.hasTargetClasses()}
                                                            type="checkbox"
                                                        />
                                                        <label className="custom-control-label" htmlFor="input-tt-cb">
                                                            {resourceStrings.all_class_types}
                                                        </label>
                                                        <div>
                                                            <i>
                                                                <small>{resourceStrings.all_class_types_expl}</small></i>
                                                        </div>
                                                    </div>

                                                    {this.state.ticketType.target_classes && this.state.ticketType.target_classes.length > 0 &&
                                                        <div style={{marginBottom: 12}}>
                                                            <Button
                                                                color="secondary"
                                                                size="lg"
                                                                onClick={e => this.showCTModal(e)}
                                                            >
                                                                ({this.state.selectedClassTypes ? this.state.selectedClassTypes.length : (this.state.ticketType.target_classes ? this.state.ticketType.target_classes.length : "0")}) {resourceStrings.manage_ct}
                                                            </Button>
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                        }

                                        <hr style={{margin: 20}}/>

                                        {/*GROUPS*/}
                                        <Row>
                                            <Col lg="12">
                                                <div
                                                    className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                    <input
                                                        className="custom-control-input"
                                                        id="input-group-cb"
                                                        onChange={this.handleGroupCbChange}
                                                        checked={!this.hasGroups()}
                                                        type="checkbox"
                                                    />
                                                    <label className="custom-control-label" htmlFor="input-group-cb">
                                                        {resourceStrings.all_groups}
                                                    </label>
                                                    <div>
                                                        <i>
                                                            <small>{resourceStrings.all_groups_expl}</small></i>
                                                    </div>
                                                </div>

                                                {((this.state.selectedStudentGroups && this.state.selectedStudentGroups.length > 0) || (this.state.ticketType.groups && this.state.ticketType.groups.length > 0)) &&
                                                    <div style={{marginBottom: 12}}>
                                                        <Button
                                                            color="secondary"
                                                            size="lg"
                                                            onClick={e => this.showGroupModal(e)}
                                                        >
                                                            ({this.state.selectedStudentGroups ? this.state.selectedStudentGroups.length : (this.state.ticketType.groups ? this.state.ticketType.groups.length : "0")}) {commonStrings.select_groups}
                                                        </Button>
                                                    </div>
                                                }
                                            </Col>
                                        </Row>

                                        <hr style={{margin: 20}}/>

                                        {!this.state.ticketType.is_enrolment &&

                                            <Row>
                                                <Col lg="12">
                                                    <div
                                                        className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                        <input
                                                            className="custom-control-input"
                                                            id="input-ticket-types-cb"
                                                            onChange={this.handleTicketTypeSelectionCbChange}
                                                            checked={!this.allTicketCovered()}
                                                            type="checkbox"
                                                        />
                                                        <label className="custom-control-label"
                                                               htmlFor="input-ticket-types-cb">
                                                            {resourceStrings.tt_unlocks_tts}
                                                        </label>
                                                        <div>
                                                            <i> <small>{resourceStrings.tt_unlocks_tts_expl}</small></i>
                                                        </div>
                                                    </div>

                                                    {this.state.selectedTicketTypes && this.state.selectedTicketTypes.length > 0 &&
                                                        <div>
                                                            <Button
                                                                color="secondary"
                                                                size="lg"
                                                                onClick={e => this.showTTModal(e)}
                                                            >
                                                                ({this.state.selectedTicketTypes.length}) {resourceStrings.manage_tt}
                                                            </Button>
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                        }

                                        {!this.state.ticketType.is_enrolment &&

                                            <Row>
                                                <Col lg="12">
                                                    <div
                                                        className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                        <input
                                                            className="custom-control-input"
                                                            id="input-workshop-cb"
                                                            onChange={this.handleChange}
                                                            checked={this.state.ticketType.is_workshop == true}
                                                            type="checkbox"
                                                        />
                                                        <label className="custom-control-label"
                                                               htmlFor="input-workshop-cb">
                                                            {resourceStrings.workshop_ticket}
                                                        </label>
                                                        <div>
                                                            <i>
                                                                <small>{resourceStrings.workshop_ticket_expl}</small></i>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>
                                        }

                                        {this.state.ticketType.is_enrolment &&

                                            <Row>
                                                <Col lg="12">
                                                    <div
                                                        className="custom-control custom-control-alternative custom-checkbox mb-3">
                                                        <input
                                                            className="custom-control-input"
                                                            id="input-all-tickets-cb"
                                                            onChange={this.handleTicketTypeCbChange}
                                                            checked={this.allTicketCovered()}
                                                            type="checkbox"
                                                        />
                                                        <label className="custom-control-label"
                                                               htmlFor="input-all-tickets-cb">
                                                            {resourceStrings.covered_tickets_all}
                                                        </label>
                                                        <div>
                                                            <i> <small>{resourceStrings.covered_tickets}</small></i>
                                                            {!this.allTicketCovered() &&
                                                                <div onClick={e => this.showTTModal(e)}>
                                                                    <i> <small style={{
                                                                        color: "#374b22",
                                                                        fontWeight: 600,
                                                                        textDecorationLine: 'underline'
                                                                    }}>{this.state.selectedTicketTypes.map((tt) => {
                                                                        return tt.name
                                                                    }).join(", ")}</small></i>
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>

                                                    {this.state.ticketType.target_classes && this.state.ticketType.target_classes.length > 0 &&
                                                        <div>
                                                            <Button
                                                                color="secondary"
                                                                size="lg"
                                                                onClick={e => this.showCTModal(e)}
                                                            >
                                                                ({this.state.selectedClassTypes ? this.state.selectedClassTypes.length : (this.state.ticketType.target_classes ? this.state.ticketType.target_classes.length : "0")}) {resourceStrings.manage_ct}
                                                            </Button>
                                                        </div>
                                                    }
                                                </Col>
                                            </Row>
                                        }

                                        {this.state.ticketType.is_enrolment &&
                                            <div className="alert-danger" style={{
                                                margin: 24,
                                                padding: 12,
                                                borderRadius: 10
                                            }}>{resourceStrings.enrolment_warning}</div>
                                        }

                                    </div>
                                }

                                <Row>
                                    <Col lg="12">
                                        <Col className="text-right">
                                            <Button
                                                color="warning"
                                                href="#pablo"
                                                outline="button"
                                                size="lg"
                                                onClick={e => this.props.closeTicketTypeView(e)}
                                            >
                                                {commonStrings.close}
                                            </Button>

                                            <Button
                                                color={this.validationCleared() ? "default" : "secondary"}
                                                disabled={!this.validationCleared()}
                                                href="#pablo"
                                                size="lg"
                                                onClick={e => this.updateTicketType(e)}
                                            >
                                                {commonStrings.save}
                                            </Button>
                                        </Col>
                                    </Col>
                                </Row>

                                <hr/>

                                {this.state.ticketType.membership &&
                                    <Row className="mt-6 justify-content-center pl-4 pr-4" style={{
                                        display: "flex",
                                        textAlign: "left",
                                        alignItems: "center",  // verticall center
                                        justifyContent: "center", // horizontally center
                                        width: "100%",
                                        fontWeight: "600",
                                        fontSize: '0.8rem',
                                        overflowWrap: 'break-word',
                                        whiteSpace: "pre-line"
                                    }}>
                                        {resourceStrings.memberships.membership_expl}
                                    </Row>}

                            </Form>
                        }

                        {this.state.ticketType.price_id &&
                            <Row>
                                {/*STRIPE DATA*/}
                                <Col lg="12" style={{marginLeft: 10, marginTop: 10}}>
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <small style={{fontWeight: 600}}>
                                            Stripe Price: <a
                                            href={`https://dashboard.stripe.com/prices/${this.state.ticketType.price_id}`}
                                            target="_blank">{this.state.ticketType.price_id}</a> <br/>
                                            Stripe Product: <a
                                            href={`https://dashboard.stripe.com/products/${this.state.ticketType.product_id}`}
                                            target="_blank">{this.state.ticketType.product_id}</a> <br/>
                                        </small>

                                    </FormGroup>
                                </Col>
                            </Row>
                        }

                        {this.state.mode == "m" &&
                            <>

                                <label
                                    className="form-control-label ml-4"
                                    htmlFor="input-name"
                                    onClick={e => this.toggleShowMembershipExplanation(e)}
                                    style={{cursor: "pointer", color: "blue", textDecoration: "underline"}}
                                >
                                    <i className="fas fa-info-circle"/> {resourceStrings.memberships.about_memberships}
                                </label>

                                {this.state.showMembershipExplanation == true &&

                                    <Row className="mt-2 mb-4 justify-content-center pl-5 pr-4" style={{
                                        display: "flex",
                                        textAlign: "left",
                                        alignItems: "center",  // verticall center
                                        justifyContent: "center", // horizontally center
                                        width: "100%",
                                        fontWeight: 400,
                                        fontSize: '0.8rem',
                                        overflowWrap: 'break-word',
                                        whiteSpace: "pre-line"
                                    }}>
                                        {resourceStrings.memberships.membership_expl}
                                    </Row>
                                }

                                <div>
                                    {this.renderMembershipView()}
                                </div>
                            </>
                        }
                    </CardBody>
                </Card>
            </>
        )
    }

    toggleShowMembershipExplanation(e) {
        e.preventDefault();
        const nv = !this.state.showMembershipExplanation
        this.setState({showMembershipExplanation: nv})
    }

    renderMembershipView() {
        return businessHelper.businessHasConnectedStripeAccount() ? this.renderMembershipForm() : this.renderMembershipExplanation()
    }

    renderMembershipForm() {
        return (
            <>
                <Form onSubmit={this.handleSubmit}>
                    {this.state.ticketType &&
                        <div className="pl-lg-4">
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-name"
                                        >
                                            {resourceStrings.title}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.title}
                                            className={this.state.validation.name === true ? "form-control-alternative" : "is-invalid"}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.ticketType.name}
                                            id="input-name"
                                            type="name"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-note"
                                        >
                                            {resourceStrings.description}
                                        </label>
                                        <Input
                                            placeholder={resourceStrings.tt_description_placeholder}
                                            className={"form-control-alternative"}
                                            onChange={this.handleChange}
                                            defaultValue={this.state.ticketType.note}
                                            id="input-note"
                                            rows="2"
                                            type="textarea"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-duration"
                                        >
                                            {resourceStrings.ticket_valid_for}
                                        </label>

                                        {this.state.ticketType.duration !== constants.open.ENDLESS_TICKET &&
                                            <Row className="align-content-center"
                                                 style={{display: "flex", alignItems: "center"}}>
                                                <Col lg="2">
                                                    <Input
                                                        disabled={true}
                                                        placeholder={1}
                                                        className="form-control-alternative"
                                                        onChange={this.handleChange}
                                                        value={1}
                                                        id="input-duration"
                                                        type="number"
                                                    />
                                                </Col>
                                                <Col lg="4">
                                                    <Button
                                                        color="secondary"
                                                        size="sm"
                                                        disabled={true}
                                                        onClick={e => this.setUnits(e, "d")}
                                                    >
                                                        {resourceStrings.ticket_days}
                                                    </Button>

                                                    <Button
                                                        color="warning"
                                                        size="sm"
                                                        onClick={e => e.preventDefault()}
                                                    >
                                                        {resourceStrings.ticket_months}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        }
                                    </FormGroup>
                                </Col>
                            </Row>

                            <hr style={{marginTop: -2}}/>
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-duration"
                                        >
                                            {resourceStrings.ticket_duration}
                                        </label>

                                        <Row style={{display: "flex", alignItems: "center"}}>
                                            {this.state.ticketType.classes_left > -1 &&
                                                <Col lg="2">
                                                    <div>
                                                        <Input
                                                            placeholder={resourceStrings.classes}
                                                            className={this.state.validation.classes_left === true ? "form-control-alternative" : "is-invalid"}
                                                            onChange={this.handleChange}
                                                            value={this.state.ticketType.classes_left}
                                                            id="input-classes-left"
                                                            type="number"
                                                            min={0}
                                                        />

                                                    </div>

                                                </Col>
                                            }
                                            {this.state.ticketType.classes_left > -1 &&
                                                <Col lg="2">
                                                    {resourceStrings.classes}
                                                </Col>
                                            }
                                            <Col lg="6">
                                                <div
                                                    className="custom-control custom-control-alternative custom-checkbox">
                                                    <input
                                                        className="custom-control-input"
                                                        id="input-unlimited-cb"
                                                        onChange={this.handleUnlimitedChange}
                                                        checked={this.state.ticketType.classes_left === constants.open.UNLIMITED_TICKET}
                                                        type="checkbox"
                                                    />
                                                    <label className="custom-control-label"
                                                           htmlFor="input-unlimited-cb">
                                                        {resourceStrings.unlimited_ticket}
                                                    </label>
                                                </div>
                                            </Col>
                                        </Row>

                                    </FormGroup>
                                </Col>
                            </Row>

                            <hr style={{marginTop: -2}}/>
                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-price"
                                        >
                                            {resourceStrings.price}
                                        </label>

                                        <Row style={{display: "flex", alignItems: "center"}}>
                                            <Col lg="2" md="2" sm="8" xs="8">
                                                <div>
                                                    <Input
                                                        className={this.state.validation.price === true ? "form-control-alternative" : "is-invalid"}
                                                        onChange={this.handleChange}
                                                        value={this.state.ticketType.price}
                                                        id="input-price"
                                                        type="number"
                                                        min={0}
                                                        pattern="^\d+(?:\.\d{1,2})?$"
                                                        placeholder="0.00"
                                                    />

                                                </div>

                                            </Col>
                                            <Col lg="2" md="2" sm="4" xs="4">
                                                {businessHelper.currency()}
                                            </Col>
                                        </Row>

                                    </FormGroup>
                                </Col>
                            </Row>

                            <hr style={{marginTop: -2}}/>

                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                            htmlFor="input-duration"
                                        >
                                            {resourceStrings.active_from}
                                        </label>

                                        <Row style={{display: "flex", alignItems: "center"}}>
                                            <Col lg="6">
                                                <div
                                                    className="custom-control custom-control-alternative custom-checkbox">
                                                    <input
                                                        className="custom-control-input"
                                                        id="input-first-cb"
                                                        onChange={e => this.handleActiveFromCb(e, "f")}
                                                        checked={this.state.ticketType.start_first_day === true}
                                                        type="checkbox"
                                                    />
                                                    <label className="custom-control-label"
                                                           htmlFor="input-first-cb">
                                                        {resourceStrings.active_from_first}
                                                    </label>
                                                </div>
                                                <div
                                                    className="custom-control custom-control-alternative custom-checkbox mt-2">
                                                    <input
                                                        className="custom-control-input"
                                                        id="input-day-cb"
                                                        onChange={e => this.handleActiveFromCb(e, "d")}
                                                        checked={(this.state.ticketType.start_first_day != true && this.state.ticketType.starts_on_use != true)}
                                                        type="checkbox"
                                                    />
                                                    <label className="custom-control-label"
                                                           htmlFor="input-day-cb">
                                                        {resourceStrings.active_from_day}
                                                    </label>
                                                </div>
                                            </Col>
                                        </Row>

                                    </FormGroup>
                                </Col>
                            </Row>

                            <hr style={{marginTop: -2}}/>

                            <Row>
                                <Col lg="12">
                                    <FormGroup style={{verticalAlign: 'center='}}>
                                        <label
                                            className="form-control-label"
                                        >
                                            {resourceStrings.limit_by_day_week_expl}
                                        </label>

                                        {(this.state.ticketType.limit && this.state.ticketType.limit.length > 1) &&
                                            <Row className="align-content-center"
                                                 style={{display: "flex", alignItems: "center"}}>
                                                <Col lg="2">
                                                    <Input
                                                        placeholder={resourceStrings.duration}
                                                        className={this.state.validation.duration === true ? "form-control-alternative" : "is-invalid"}
                                                        onChange={this.handleLimitChange}
                                                        value={this.getLimitValue()}
                                                        id="input-limit"
                                                        min={0}
                                                        type="number"
                                                    />
                                                </Col>
                                                <Col lg="2">
                                                    {resourceStrings.times_per}
                                                </Col>
                                                <Col lg="4">
                                                    <Button
                                                        color={(this.state.ticketType.limit && this.state.ticketType.limit.includes("d")) ? "warning" : "secondary"}
                                                        size="sm"
                                                        onClick={e => this.setLimitUnits(e, "d")}
                                                    >
                                                        {commonStrings.day}
                                                    </Button>

                                                    <Button
                                                        color={(this.state.ticketType.limit && this.state.ticketType.limit.includes("w")) ? "warning" : "secondary"}
                                                        size="sm"
                                                        onClick={e => this.setLimitUnits(e, "w")}
                                                    >
                                                        {commonStrings.week}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        }

                                        <div
                                            className="custom-control custom-control-alternative custom-checkbox mb-3 mt-2">
                                            <input
                                                className="custom-control-input"
                                                id="input-no-limit-cb"
                                                onChange={event => this.handleNoLimitChange(event)}
                                                checked={(!this.state.ticketType.limit || this.state.ticketType.limit.length < 2)}
                                                type="checkbox"
                                            />
                                            <label className="custom-control-label" htmlFor="input-no-limit-cb">
                                                {resourceStrings.no_limit_by_day_week}
                                            </label>
                                        </div>
                                    </FormGroup>
                                </Col>
                            </Row>

                            <hr style={{marginTop: -2}}/>

                            <Row>
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-public-cb"
                                            onChange={this.handleChange}
                                            checked={this.state.ticketType.whitelisted === true}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-public-cb">
                                            {resourceStrings.public}
                                        </label>
                                        <div>
                                            <i><small>{resourceStrings.public_ticket_expl}</small></i>
                                        </div>
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="12">
                                    <div className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-tt-cb"
                                            onChange={this.handleClassTypeCbChange}
                                            checked={!this.hasTargetClasses()}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-tt-cb">
                                            {resourceStrings.all_class_types}
                                        </label>
                                        <div>
                                            <i> <small>{resourceStrings.all_class_types_expl}</small></i>
                                        </div>
                                    </div>

                                    {this.state.ticketType.target_classes && this.state.ticketType.target_classes.length > 0 &&
                                        <div>
                                            <Button
                                                color="secondary"
                                                size="lg"
                                                onClick={e => this.showCTModal(e)}
                                            >
                                                ({this.state.selectedClassTypes ? this.state.selectedClassTypes.length : (this.state.ticketType.target_classes ? this.state.ticketType.target_classes.length : "0")}) {resourceStrings.manage_ct}
                                            </Button>
                                        </div>
                                    }
                                </Col>
                            </Row>

                            {/*GROUPS*/}
                            <Row>
                                <Col lg="12">
                                    <div
                                        className="custom-control custom-control-alternative custom-checkbox mb-3">
                                        <input
                                            className="custom-control-input"
                                            id="input-group-cb"
                                            onChange={this.handleGroupCbChange}
                                            checked={!this.hasGroups()}
                                            type="checkbox"
                                        />
                                        <label className="custom-control-label" htmlFor="input-group-cb">
                                            {resourceStrings.all_groups}
                                        </label>
                                        <div>
                                            <i>
                                                <small>{resourceStrings.all_groups_expl}</small></i>
                                        </div>
                                    </div>

                                    {((this.state.selectedStudentGroups && this.state.selectedStudentGroups.length > 0) || (this.state.ticketType.groups && this.state.ticketType.groups.length > 0)) &&
                                        <div style={{marginBottom: 12}}>
                                            <Button
                                                color="secondary"
                                                size="lg"
                                                onClick={e => this.showGroupModal(e)}
                                            >
                                                ({this.state.selectedStudentGroups ? this.state.selectedStudentGroups.length : (this.state.ticketType.groups ? this.state.ticketType.groups.length : "0")}) {commonStrings.select_groups}
                                            </Button>
                                        </div>
                                    }
                                </Col>
                            </Row>


                        </div>
                    }

                    <Row>
                        <Col lg="12">
                            <Col className="text-right">
                                <Button
                                    color="warning"
                                    href="#pablo"
                                    outline="button"
                                    size="lg"
                                    onClick={e => this.props.closeTicketTypeView(e)}
                                >
                                    {commonStrings.close}
                                </Button>

                                <Button
                                    color={this.validationCleared() ? "default" : "secondary"}
                                    disabled={!this.validationCleared()}
                                    href="#pablo"
                                    size="lg"
                                    onClick={e => this.updateMembershipTicketType(e)}
                                >
                                    {commonStrings.save}
                                </Button>
                            </Col>
                        </Col>
                    </Row>

                </Form>
            </>
        )
    }

    renderMembershipExplanation() {
        return (
            <>
                <Row className="mt-6 justify-content-center pl-6 pr-6" style={{
                    display: "flex",
                    textAlign: "left",
                    alignItems: "center",  // verticall center
                    justifyContent: "center", // horizontally center
                    width: "100%",
                    fontWeight: "600",
                    fontSize: '0.8rem',
                    overflowWrap: 'break-word',
                    whiteSpace: "pre-line"
                }}>
                    {resourceStrings.memberships.membership_expl}
                </Row>
                <Row className="mt-6" style={{
                    display: "flex",
                    alignItems: "center",  // verticall center
                    justifyContent: "center", // horizontally center
                    width: "100%"
                }}>
                    <Button
                        style={{
                            display: "flex",
                            alignItems: "center"
                        }}
                        color="info"
                        size="lg"
                        onClick={e => this.connectStripeAction(e)}
                    >
                        {resourceStrings.public_profile.connect_stripe}
                    </Button>
                </Row>
            </>)
    }

    handleValidation() {
        this.validateName();
        this.validateClasses();
        this.validatePrice();
    }

    validateName() {
        const name = this.state.ticketType.name;

        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                name: name.length >= 2
            }
        }));
    }

    validateClasses() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                classes_left: this.state.ticketType.classes_left === -5 || this.state.ticketType.classes_left > -1,
            }
        }));
    }

    validateDuration() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                durations: this.state.ticketType.duration === -3 || this.state.ticketType.duration > -1,
            }
        }));
    }

    validatePrice() {
        this.setState(prevState => ({
            validation: {
                ...prevState.validation,
                price: parseFloat(this.state.ticketType.price) >= 0
            }
        }));
    }

    validationCleared() {
        return Object.values(this.state.validation).every(item => item)
    }

    localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
        // alertStrings.setLanguage(loc);
    }

    updateTicketType() {
        this.setState({isLoading: true});

        const ct = this.state.ticketType;
        ct.group_ids = (this.state.selectedStudentGroups || []).map(sg => sg.id).join(",")
        ct.groups = []
        if (this.state.selectedClassTypes !== null) {
            if (this.state.selectedClassTypes.length > 0) {
                ct.ct_ids = this.state.selectedClassTypes.map(it => it.id).join(",");
            } else {
                ct.ct_ids = -1;
            }
        }

        if (this.state.selectedTicketTypes != null) {
            if (this.state.selectedTicketTypes.length > 0) {
                ct.tt_ids = this.state.selectedTicketTypes.map(it => it.id).join(",");
            } else {
                ct.tt_ids = -1;
            }
        }

        if (ct.is_enrolment) {
            ct.classes_left = -5
            ct.duration = -3
        }

        if (this.state.ticketType.id) {

            ResourceApiService.updateTicketType(ct)
                .then(res => {
                    this.setState({
                        ticketType: res,
                        isLoading: false
                    });

                    this.props.closeTicketTypeView(null, res)
                })
                .catch((e) => {
                    this.props.handleError(e)
                });

        } else {
            ResourceApiService.postTicketType(ct)
                .then(res => {
                    this.setState({
                        ticketType: res,
                        isLoading: false
                    });

                    if (this.state.promoCodesToAdd && this.state.promoCodesToAdd.length > 0) {
                        this.savePromoCode(null, this.state.promoCodesToAdd[0])
                    } else {
                        this.props.closeTicketTypeView(null, res)
                    }
                })
                .catch((e) => {
                    this.props.handleError(e)
                });
        }
    }

    showCTModal(e) {
        if (this.state.selectedClassTypes === null) {
            this.setState({selectedClassTypes: this.state.ticketType.target_classes});
        }

        if (e) e.preventDefault();

        if (this.state.classTypes === null) this.getClassTypes();
        else {
            this.setState({showCTModal: true})
        }
    }

    showGroupModal(e) {
        if (this.state.selectedStudentGroups === null) {
            this.setState({selectedStudentGroups: this.state.ticketType.groups, mustShowGroupSelector: true});
        } else {
            this.setState({mustShowGroupSelector: true})
        }
    }

    showTTModal(e) {
        console.log("Displaying ticket types")
        if (e) e.preventDefault();

        this.setState({showTTModal: true})
    }

    toggleCTModal = state => {
        this.setState({
            showCTModal: !this.state.showCTModal
        });
    };

    toggleCGModal = state => {
        this.setState({
            mustShowGroupSelector: !this.state.mustShowGroupSelector
        });
    };

    toggleTTModal = state => {
        this.setState({
            showTTModal: !this.state.showTTModal
        });
    };

    renderCTModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showCTModal}
                toggle={() => this.toggleCTModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {resourceStrings.manage_ct}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleCTModal()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        {(!this.state.classTypes || this.state.classTypes.length === 0) &&
                            <CardHeader className="bg-transparent pb-2">
                                <div className="text-muted text-center mt-2 mb-3">
                                    <small style={{color: "red"}}>{resourceStrings.no_ct}</small>
                                </div>
                            </CardHeader>
                        }
                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <tbody>
                            {this.renderCTable()}
                            </tbody>
                        </Table>
                    </Card>
                </div>
            </Modal>
        )
    }

    renderSgModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.mustShowGroupSelector}
                toggle={() => this.toggleCGModal("formModal")}
            >
                <div className="modal-header">
                    <h5 className="modal-title" id="modal-title-notification">
                        {commonStrings.select_groups}
                    </h5>

                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleCGModal()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        {(!this.state.studentGroups || this.state.studentGroups.length === 0) &&
                            <CardHeader className="bg-transparent pb-2">
                                <div className="text-muted text-center mt-2 mb-3">
                                    <small style={{color: "red"}}>{commonStrings.no_ranks_expl}</small>
                                </div>
                            </CardHeader>
                        }
                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <tbody>
                            {this.renderCGTable()}
                            </tbody>
                        </Table>
                    </Card>
                </div>
            </Modal>
        )
    }

    renderTTModal() {
        return (
            <Modal
                className="modal-dialog-centered"
                size="lg"
                isOpen={this.state.showTTModal}
                toggle={() => this.toggleTTModal("formModal")}
            >
                <div className="modal-header">
                    <h6 className="modal-title" id="modal-title-notification">
                        {resourceStrings.manage_tt}
                    </h6>
                    <button
                        aria-label="Close"
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => this.toggleTTModal()}
                    >
                        <span aria-hidden={true}>×</span>
                    </button>
                </div>

                <div className="modal-body p-0">

                    <Card className="bg-secondary shadow border-0">
                        {(!this.state.ticketTypes || this.state.ticketTypes.length == 0) &&
                            <CardHeader className="bg-transparent pb-2">

                                <div className="text-muted text-center mt-2 mb-3">
                                    <small style={{color: "red"}}>{resourceStrings.no_tt}</small>
                                </div>
                            </CardHeader>
                        }
                        <Table
                            className="align-items-center table-light table-flush mt-2"
                            responsive
                        >
                            <thead className="thead-dark">
                            <tr>
                                <th scope="col"></th>
                            </tr>
                            </thead>
                            <tbody>
                            {this.renderTTable()}
                            </tbody>
                        </Table>
                    </Card>
                </div>
            </Modal>
        )
    }

    getClassTypes() {
        this.setState({isLoading: true});

        ResourceApiService.classTypes()
            .then(res => {
                this.setState({
                    classTypes: res,
                    isLoading: false
                });

                this.showCTModal()

            })
            .catch((e) => {
                this.props.handleError(e)
            });
    }

    renderCTable() {
        const selected = (this.state.selectedClassTypes) ? this.state.selectedClassTypes.map(it => it.id) : this.state.ticketType.target_classes.map(it => it.id) || []
        return (this.state.classTypes).map((tt, index) => {

            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleCTSelected}/>
            )
        })
    };

    renderCGTable() {
        const selected = (this.state.selectedStudentGroups) ? this.state.selectedStudentGroups.map(it => it.id) : (this.state.ticketType.groups || []).map(it => it.id) || []
        return (this.state.studentGroups).map((sg, index) => {

            return (
                <CheckBoxList item={{id: sg.id, label: sg.title}} key={sg.id}
                              selected={selected.includes(sg.id)}
                              handleChange={this.handleStudentGroupSelected}/>
            )
        })
    };

    renderTTable() {
        const selected = (this.state.selectedTicketTypes) ? this.state.selectedTicketTypes.map(it => it.id) : this.state.ticketType.covered_tickets.map(it => it.id) || [];
        const currentTicketTypeId = this.state.ticketType && this.state.ticketType.id ? this.state.ticketType.id : -1;
        const filteredTickets = this.state.ticketTypes.filter((tt) => {
            return !tt.is_enrolment && tt.id != currentTicketTypeId
        });

        return filteredTickets.map((tt, index) => {
            return (
                <CheckBoxList item={{id: tt.id, label: tt.name}} key={tt.id}
                              selected={selected.includes(tt.id)}
                              handleChange={this.handleTicketTypeSelected}/>
            )
        })
    };

    //must be renamed
    handleCTSelected(checked, id) {
        const tt = this.state.classTypes.find(it => it.id === id);
        const selected = ((this.state.selectedClassTypes) ? this.state.selectedClassTypes : []);
        const selectedIds = ((this.state.selectedClassTypes) ? this.state.selectedClassTypes : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);

                    this.setState({selectedClassTypes: selected});
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);

                    this.setState({selectedClassTypes: selected});

                }
            }
        }
    }

    handleStudentGroupSelected(checked, id) {
        const tt = this.state.studentGroups.find(it => it.id === id);
        const selected = ((this.state.selectedStudentGroups) ? this.state.selectedStudentGroups : []);
        const selectedIds = ((this.state.selectedStudentGroups) ? this.state.selectedStudentGroups : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);

                    this.setState({selectedStudentGroups: selected});
                    this.setState(prevState => ({
                        editingPromoCode: {
                            ...prevState.editingPromoCode,
                            groups: selected
                        }
                    }));
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);

                    this.setState({selectedStudentGroups: selected});
                    this.setState(prevState => ({
                        editingPromoCode: {
                            ...prevState.editingPromoCode,
                            groups: selected
                        }
                    }));

                }
            }
        }
    }

    handleTicketTypeSelected(checked, id) {
        const tt = this.state.ticketTypes.find(it => it.id === id);
        const selected = ((this.state.selectedTicketTypes) ? this.state.selectedTicketTypes : []);
        const selectedIds = ((this.state.selectedTicketTypes) ? this.state.selectedTicketTypes : []).map(it => it.id);

        if (tt) {
            if (checked) {
                if (!selectedIds.includes(tt.id)) {
                    selected.push(tt);

                    this.setState({selectedTicketTypes: selected});
                }
            } else {
                if (selectedIds.includes(tt.id)) {
                    const index = selectedIds.indexOf(tt.id);
                    if (index !== -1) selected.splice(index, 1);

                    this.setState({selectedTicketTypes: selected});

                }
            }
        }
    }

    setUnits(e, units) {
        e.preventDefault();

        this.setState(prevState => ({
            ticketType: {
                ...prevState.ticketType,
                units: units
            }
        }));
    }

    handleEndlessChange(event) {
        const checked = event.target.checked;

        this.setState(prevState => ({
            ticketType: {
                ...prevState.ticketType,
                duration: checked ? constants.open.ENDLESS_TICKET : 7
            }
        }));
    }

    handleUnlimitedChange(event) {
        const checked = event.target.checked;

        this.setState(prevState => ({
            ticketType: {
                ...prevState.ticketType,
                classes_left: checked ? constants.open.UNLIMITED_TICKET : 10
            }
        }));
    }

    ticketDuration() {
        return this.state.ticketType.duration === constants.open.ENDLESS_TICKET ? 0 : this.state.ticketType.duration
    }

    hasTargetClasses() {
        return this.state.selectedClassTypes && this.state.selectedClassTypes.length > 0 ? true :
            this.state.selectedClassTypes && this.state.selectedClassTypes.length === 0 ? false : (this.state.ticketType.target_classes && this.state.ticketType.target_classes.length > 0)
    }

    hasGroups() {
        return this.state.selectedStudentGroups && this.state.selectedStudentGroups.length > 0 ? true :
            this.state.selectedStudentGroups && this.state.selectedStudentGroups.length === 0 ? false : (this.state.ticketType.groups && this.state.ticketType.groups.length > 0)
    }

    allTicketCovered() {
        return !this.state.selectedTicketTypes || this.state.selectedTicketTypes.length == 0
    }

    toggleEditPromoCode(event) {
        event.preventDefault()
        if (this.state.editingPromoCode) {
            this.setState({editingPromoCode: null, hoveredPC: null})
        } else {
            this.setState({editingPromoCode: resourceHelper.emptyPromoCode()})
        }
    }

    savePromoCode(event, promoCode = null) {
        if (event) event.preventDefault()

        const pc = promoCode ? promoCode : this.state.editingPromoCode;
        if (!pc) {
            return;
        }

        if (!pc.code || pc.code.length < 2) {
            this.setState({wrongPromoCodeTitle: true})
            return;
        }

        if (!pc.discount_perc || pc.discount_perc < 1 || pc.discount_perc > 99) {
            this.setState({wrongPromoCodeDiscount: true})
            return;
        }

        this.setState({promoCodesToAdd: [pc], editingPromoCode: null, selectedStudentGroups: [], hoveredPC: null});

        if (this.state.ticketType && this.state.ticketType.id) {
            pc.ticket_type_id = this.state.ticketType.id

            this.setState({isLoading: true, promoCodesToAdd: null});

            ResourceApiService.createPromoCode(pc)
                .then(res => {
                    this.setState({
                        promoCodes: res,
                        isLoading: false
                    });

                    if (promoCode) {
                        this.props.closeTicketTypeView(null);
                    }
                })
                .catch((e) => {
                    this.props.handleError(e)
                    this.setState({
                        isLoading: false
                    });
                });
        } else {
            this.setState({promoCodes: [pc]});
        }
    }

    handleActiveFromCb(event, d) {
        const checked = event.target.checked;
        if (checked) {
            this.setState(prevState => ({
                ticketType: {
                    ...prevState.ticketType,
                    start_first_day: d == "f",
                    starts_on_use: d == "u"
                }
            }));
        }
    }

    handleLimitChange(event) {
        let curValue = this.state.ticketType.limit;
        if (curValue && curValue.includes("-")) {
            curValue = curValue.split("-")
        } else curValue = ["d", 0];

        const value = event.target.value;
        const valInt = parseInt(value);
        if (valInt && valInt > 0) {
            this.setState(prevState => ({
                ticketType: {
                    ...prevState.ticketType,
                    limit: [curValue[0], valInt].join("-")
                }
            }));
        } else
            this.setState(prevState => ({
                ticketType: {
                    ...prevState.ticketType,
                    limit: ""
                }
            }));
    }

    getLimitValue() {
        const l = this.state.ticketType.limit;
        if (l && l.length > 0 && l.includes("-")) {
            return l.split("-")[1]
        } else return ""
    }

    setLimitUnits(e, value) {
        e.preventDefault();

        let curValue = this.state.ticketType.limit;
        if (curValue && curValue.includes("-")) {
            curValue = curValue.split("-")
        } else curValue = ["d", 0];

        this.setState(prevState => ({
            ticketType: {
                ...prevState.ticketType,
                limit: [value, curValue[1]].join("-")
            }
        }));
    }

    handleNoLimitChange(event) {
        if (event.target.checked) {
            this.setState(prevState => ({
                ticketType: {
                    ...prevState.ticketType,
                    limit: ""
                }
            }));
        } else {
            this.setState(prevState => ({
                ticketType: {
                    ...prevState.ticketType,
                    limit: "d-2"
                }
            }));
        }
    }

    connectStripeAction(e) {
        e.preventDefault();
        window.location.replace(`https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_FVVYQ2LLjNcHkpAX2boYnb7ChHJDTXGp&scope=read_write&&redirect_uri=https://www.openmanagerapp.com/admin/`);
    }

    updateMembershipTicketType() {
        this.setState({isLoading: true});

        const ct = this.state.ticketType;
        ct.group_ids = (this.state.selectedStudentGroups || []).map(sg => sg.id).join(",")
        ct.groups = []
        if (this.state.selectedClassTypes !== null) {
            if (this.state.selectedClassTypes.length > 0) {
                ct.ct_ids = this.state.selectedClassTypes.map(it => it.id).join(",");
            } else {
                ct.ct_ids = -1;
            }
        }

        if (this.state.ticketType.id) {

            ResourceApiService.updateTicketType(ct)
                .then(res => {
                    this.setState({
                        ticketType: res,
                        isLoading: false
                    });

                    this.props.closeTicketTypeView(null, res)
                })
                .catch((e) => {
                    this.props.handleError(e)
                });

        } else {
            ResourceApiService.postMembershipTicketType(ct)
                .then(res => {
                    this.setState({
                        ticketType: res.ticket_type,
                        isLoading: false
                    });

                    this.props.closeTicketTypeView(null, res)
                })
                .catch((e) => {
                    this.props.handleError(e)
                });
        }
    }

}

EditTicketTypeView.propTypes = propTypes;

export default EditTicketTypeView;